import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Message} from 'primeng/api';

type Severity = 'success' | 'info' | 'warn' | 'error';

@Injectable()
export class GlobalMessagesService {

  // Observable message source
  private messageSource = new Subject<Message>();


  // Observable message stream
  messageSent$ = this.messageSource.asObservable();

  showErrorMessage(detail: string, summary: string = '') {
    this.messageSource.next(this.create('error', detail, summary));
  }

  showInfoMessage(detail: string, summary: string = '') {
    console.log('info', summary);
    this.messageSource.next(this.create('info', detail, summary));
  }

  showWarnMessage(detail: string, summary: string = '') {
    this.messageSource.next(this.create('warn', detail, summary));
  }

  showSuccessMessage(detail: string, summary: string = '') {
    this.messageSource.next(this.create('success', detail, summary));
  }

  private create(severity: Severity, detail: string, summary: string): Message {
    return {
      'severity': severity,
      'summary': summary,
      'detail': detail
    };
  }

}
